"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var maybe_1 = require("./maybe");
function breadcrumb(url, links) {
    var itemListElement = links.map(function (_a, index) {
        var title = _a.title, link = _a.link;
        return ({
            '@type': 'ListItem',
            item: {
                '@id': "" + url + link,
                name: title
            },
            position: index + 1
        });
    });
    var breadcrumb = {
        itemListElement: itemListElement,
        '@context': 'http://schema.org',
        '@type': 'BreadcrumbList',
        description: 'Breadcrumbs list',
        name: 'Breadcrumbs'
    };
    return breadcrumb;
}
exports.breadcrumb = breadcrumb;
function schemaOrgWebPage(siteUrl, language, defaultDescription, defaultTitle, buildTime, image) {
    var url = maybe_1.value(siteUrl, '');
    var inLanguage = maybe_1.value(language, '');
    var description = maybe_1.value(defaultDescription, '');
    var name = maybe_1.value(defaultTitle, '');
    return {
        // headline,
        '@context': 'http://schema.org',
        '@type': 'WebPage',
        url: url,
        inLanguage: inLanguage,
        mainEntityOfPage: url,
        description: description,
        name: name,
        // author: {
        //   '@type': 'Person',
        //   name: author
        // },
        // copyrightHolder: {
        //   '@type': 'Person',
        //   name: author
        // },
        copyrightYear: '2019',
        // creator: {
        //   '@type': 'Person',
        //   name: author
        // },
        // publisher: {
        //   '@type': 'Person',
        //   name: author
        // },
        // datePublished: '2019-01-18T10:30:00+01:00',
        dateModified: buildTime,
        image: {
            '@type': 'ImageObject',
            url: image
        }
    };
}
exports.schemaOrgWebPage = schemaOrgWebPage;
function faqPage(askMaybe, contentsMaybe) {
    var ask = maybe_1.value(askMaybe, '');
    var contents = maybe_1.values(contentsMaybe);
    return {
        '@context': 'http://schema.org',
        '@type': 'FAQPage',
        name: '',
        mainEntity: {
            '@type': 'Question',
            name: ask,
            text: ask,
            answerCount: 1,
            acceptedAnswer: {
                '@type': 'Answer',
                text: contents
                    ? contents
                        .map(function (c) { return c && c.text; })
                        .filter(function (c) { return !!c; })
                        .join('\n')
                    : ''
            }
        }
    };
}
exports.faqPage = faqPage;
function itemList(allAnswerYaml) {
    var answers = allAnswerYaml.edges.map(function (edge) { return edge.node; });
    return {
        '@context': 'https://schema.org',
        '@type': 'ItemList',
        itemListElement: answers.map(function (_a, index) {
            var id = _a.id, ask = _a.ask;
            return ({
                '@type': 'ListItem',
                position: index + 1,
                item: {
                    '@type': 'QAPage',
                    name: ask,
                    url: "/answer/" + id
                }
            });
        })
    };
}
exports.itemList = itemList;
//# sourceMappingURL=ld.js.map